export function normalizeBoolean(value: unknown): boolean | undefined {
  if (value === true || value === 1 || value === '1' || value === 'true' || value === 'on') return true;
  if (value === false || value === 0 || value === '0' || value === 'false' || value === 'off') return false;
  return undefined;
}

export function normalizeFiniteNumber(value: unknown): number | undefined {
  if (value === '' || value === null || value === undefined) return undefined;
  const normalized = Number(value);
  return Number.isFinite(normalized) ? normalized : undefined;
}

export function normalizePrivacyRequired(value: unknown): boolean | undefined {
  if (value === true || value === 1 || value === '1' || value === 'required') return true;
  if (value === false || value === 0 || value === '0' || value === 'optional') return false;
  return undefined;
}
